import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import SendMoneyService from "../../services/send-money.service";
import { useNavigate } from "react-router";
import Loader from "../../components/loader";
import { Button, Card, Empty, Modal } from "antd";
import { AiFillStar, AiOutlineDelete, AiOutlineStar } from "react-icons/ai";
import { PatternFormat } from "react-number-format";
import { useSelector } from "react-redux";
import { modeSelector } from "../../store/selectors/app.selector";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
export default function FavouritesList() {
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const mode = useSelector(modeSelector);
  const { t } = useTranslation();
  useEffect(() => {
    getAllPayee();
  }, []);

  const getAllPayee = useCallback(async () => {
    try {
      setLoader(true);
      const response = await SendMoneyService.getFavouriteList({ mode: mode });
      if (response.status === 200) {
        setLoader(false);
        let payeeList = [];
        if (
          response.data["data"]["internalBeneList"]?.length > 0 ||
          response.data["data"]["otherBeneList"]?.length > 0 ||
          response.data["data"]["internationalBeneList"]?.length > 0
        ) {
          payeeList = [
            ...response.data["data"]["internalBeneList"],
            ...response.data["data"]["otherBeneList"],
            ...response.data["data"]["internationalBeneList"],
          ];
        }
        if (response.data["data"]["accountList"]?.length > 0) {
          response.data["data"]["accountList"].forEach((element) => {
            payeeList.push({
              payeeNickName: element.acctNickName,
              bankName: element.bankName,
              payeeAccNo: element.acctNo,
              ifscCode: element.ifscCode,
              favourite: element.favAccount,
              hasAccount: true,
            });
          });
        }
        setDataSource(payeeList || []);
        setNoRecords(payeeList.length > 0 ? false : true);
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  const addFavouritePayee = useCallback(async (option) => {
    try {
      const response =
        option?.hasAccount === true
          ? await SendMoneyService.addFavOwnAccount({
              accountNo: option?.payeeAccNo,
              favorites: "N",
              beneType: option?.beneType,
            })
          : await SendMoneyService.addFavouritePayee({
              reqId: option?.reqId,
              favorites: "N",
              beneType: option?.beneType,
            });
      if (response.status === 200) {
        setMessage(response.data["message"]);
        setVisible(true);
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <div className="dashboard-accounts-wrapper">
        <div
          className="send-money-container table-body"
          style={{ minHeight: 300, padding: "10px 20px" }}
        >
          <div className="row tbl-column-header">
            <div className="col-3 d-flex align-items-center">
              {" "}
              {t("pages.Add_Bene.bane_name", {
                defaultValue: "Beneficiary Name",
              })}
            </div>
            <div className="col-2 d-flex align-items-center">
              {" "}
              {t("pages.my_accounts.casa.nickname", {
                defaultValue: "Nick Name",
              })}
            </div>
            <div className="col-2 d-flex align-items-center">
              {t("pages.payment_history.transfer_type", {
                defaultValue: "Transfer Type",
              })}
            </div>
            <div className="col-2 d-flex align-items-center">
              {t("common.account_no_lbl", {
                defaultValue: "Account Number",
              })}
            </div>
            <div className="col-2 d-flex align-items-center">
              {t("common.bank_name", {
                defaultValue: "Bank Name",
              })}
            </div>
            {/* <div className="col-2">{t("pages.standing_instruction.branch_code", {
                  defaultValue: "Branch Code",
                })}</div> */}
            <div className="col-1 d-flex align-items-center">
              {" "}
              {t("pages.Add_Bene.favourite", {
                defaultValue: "Favourite",
              })}
            </div>
          </div>

          {/* {loader && (
            <div>
              <Loader />
            </div>
          )} */}

          {noRecords && (
            <div>
              <Empty
                description={t("pages.Add_Bene.no_fav_found", {
                  defaultValue: "No Favourites found",
                })}
              />
            </div>
          )}

          {dataSource.map((option, idx) => (
            <div key={idx} className="row tbl-row-data">
              <div className="col-3">{option.beneName || "-"}</div>
              <div className="col-2">
                {" "}
                <span
                  className="payee-name"
                  // onClick={() => navigate("/send-money/payee-transfer")}
                  onClick={() =>
                    option.hasAccount === true
                      ? navigate("/send-money/payee-transfer/own", {
                          state: {
                            ...option,
                            acctNo: option.beneAccNo,
                            mode: "PAY_LIST",
                          },
                        })
                      : navigate("/send-money/payee-transfer", {
                          state: { ...option, mode: "PAY_LIST" },
                        })
                  }
                >
                  {option.beneNickName}
                </span>{" "}
              </div>
              <div className="col-2">
                {option.beneType === "INTERNAL"
                  ? t("pages.Add_Bene.internal", {
                      defaultValue: "Internal",
                    })
                  : option.beneType === "OTHERBANK"
                  ? t("pages.Add_Bene.other", {
                      defaultValue: "Other",
                    })
                  : t("pages.Add_Bene.tips", {
                      defaultValue: "Tips",
                    })}
              </div>
              <div className="col-2">{option.beneAccNo}</div>
              <div className="col-2">{option.bankName}</div>
              {/* <div className="col-2">{option.beneBrn}</div> */}
              {/* <div className="col-2">
                {option?.ifscCode !== null && option?.ifscCode?.length > 0 ? (
                  <span>
                    {option?.ifscCode.slice(0, 4)}{" "}
                    {option?.ifscCode.slice(4, option?.ifscCode?.length)}{" "}
                  </span>
                ) : (
                  "-"
                )}
              </div> */}
              <div className="col-1" align="center">
                {option.favorites === "Y" && (
                  <AiFillStar
                    onClick={() => addFavouritePayee(option)}
                    className="favourite"
                    style={{ fontSize: 22 }}
                  />
                )}
                {option.favorites === "N" && (
                  <AiOutlineStar
                    className="favourite"
                    style={{ fontSize: 22 }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal
        open={visible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                setVisible(false);
                setDataSource([]);
                getAllPayee();
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
